import { render, staticRenderFns } from "./ApiBtn.vue?vue&type=template&id=1afabbba&scoped=true"
import script from "./ApiBtn.vue?vue&type=script&lang=js"
export * from "./ApiBtn.vue?vue&type=script&lang=js"
import style0 from "./ApiBtn.vue?vue&type=style&index=0&id=1afabbba&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afabbba",
  null
  
)

export default component.exports